import { Logo } from "shared/svg";
import { Link } from "react-router-dom";

import routerList from "../../../routes/routerList";

import styles from "./AdditionalComponents.module.scss";

const NavLogo = () => {
  return (
    <Link
      className={styles.logo}
      to={routerList.carriers.list}
      aria-label="Link to Carriers"
    >
      <Logo />
    </Link>
  );
};

export default NavLogo;
